import { ToastModule } from 'primeng/toast';

import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { SvgIconComponent } from '@/app/shared/components/ui/svg-icon';

import { SETTINGS } from '@/app/shared/constants';

@Component({
  selector: 'app-toast',
  imports: [ToastModule, SvgIconComponent],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  protected readonly SETTINGS = SETTINGS;
}
